<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Rating Config</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'Home' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Rating Config</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <section class="content">
      <div class="container-fluid">
        <div class="card" id="RatingConfig">
          <div class="overlay" v-if="is_loading">
            <img src="/assets/images/loader.svg" alt="" />
          </div>
          <form @submit.prevent="handleSubmission()" method="POST" novalidate>
            <div class="card-header">
              <h3 class="card-title" v-if="!is_edit">Create</h3>
              <h3 class="card-title" v-if="is_edit">Edit</h3>
              <div class="card-tools">
                <router-link
                  class="btn btn-info"
                  :to="{ name: 'RatingConfigList' }"
                  ><i class="fas fa-list"></i> List
                </router-link>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="form-row">
                  <div class="form-group col-6 required">
                    <label class="control-label">Name</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      v-bind:class="{ 'has-error': errors.has('name') }"
                      v-validate="'required'"
                      v-model="value.name"
                      class="form-control name"
                      placeholder="Name"
                    />
                    <div class="help text-danger" v-show="errors.has('name')">
                      {{ errors.first("name") }}
                    </div>
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Description</label>
                    <input
                      type="text"
                      id="description"
                      name="description"
                      v-model="value.description"
                      class="form-control description"
                      placeholder="Description"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('description')"
                    >
                      {{ errors.first("description") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Status</label>
                    <select
                      class="form-control"
                      style="width: 100%"
                      v-bind:class="{ 'has-error': errors.has('status') }"
                      v-validate="'required'"
                      name="status"
                      v-model="value.status"
                      id="status"
                    >
                      <option :value="1">Active</option>
                      <option :value="0">Inactive</option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('status')">
                      {{ errors.first("status") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Rating-Plan</label>
                    <select
                      id="rating_plan_id"
                      name="rating_plan_id"
                      v-model="value.rating_plan_id"
                      v-bind:class="{
                        'has-error': errors.has('rating_plan_id'),
                      }"
                      v-validate="'required'"
                      class="form-control"
                    >
                      <option
                        v-for="ratingPlan in allRatingPlan"
                        :value="ratingPlan.id"
                        :key="ratingPlan.id"
                      >
                        {{ ratingPlan.name }}
                      </option>
                    </select>
                    <div
                      class="help text-danger"
                      v-show="errors.has('rating_plan_id')"
                    >
                      {{ errors.first("rating_plan_id") }}
                    </div>
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Activation Start</label>
                    <date-picker
                      type="datetime"
                      class="col-12"
                      input-class="form-control"
                      :input-attr="{ name: 'activation_start' }"
                      v-model="value.activation_start"
                      lang="en"
                      format="YYYY-MM-DD hh:mm:ss"
                      id="activation_start"
                      value-type="YYYY-MM-DD hh:mm:ss"
                    ></date-picker>
                    <div
                      class="help text-danger"
                      v-show="errors.has('activation_start')"
                    >
                      {{ errors.first("activation_start") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Activation End</label>
                    <date-picker
                      type="datetime"
                      class="col-12"
                      input-class="form-control"
                      :input-attr="{ name: 'activation_end' }"
                      v-model="value.activation_end"
                      lang="en"
                      format="YYYY-MM-DD hh:mm:ss"
                      id="activation_end"
                      value-type="YYYY-MM-DD hh:mm:ss"
                    ></date-picker>
                    <div
                      class="help text-danger"
                      v-show="errors.has('activation_end')"
                    >
                      {{ errors.first("activation_end") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Priority</label>
                    <input
                      type="text"
                      id="priority"
                      name="priority"
                      v-bind:class="{ 'has-error': errors.has('priority') }"
                      v-validate="'required'"
                      v-model="value.priority"
                      class="form-control priority"
                      placeholder="Priority"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('priority')"
                    >
                      {{ errors.first("priority") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Rating Type</label>
                    <select
                      id="rating_type_id"
                      name="rating_type_id"
                      v-model="value.rating_type_id"
                      v-bind:class="{
                        'has-error': errors.has('rating_type_id'),
                      }"
                      v-validate="'required'"
                      class="form-control"
                    >
                      <option
                        v-for="ratingType in allRatingType"
                        :value="ratingType.id"
                        :key="ratingType.id"
                      >
                        {{ ratingType.name }}
                      </option>
                    </select>
                    <div
                      class="help text-danger"
                      v-show="errors.has('rating_type_id')"
                    >
                      {{ errors.first("rating_type_id") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Rate Amount</label>
                    <input
                      type="text"
                      id="rate"
                      name="rate"
                      v-model="value.rate"
                      v-bind:class="{ 'has-error': errors.has('rate') }"
                      v-validate="'required'"
                      class="form-control rate"
                      placeholder="Rate Amount"
                    />
                    <div class="help text-danger" v-show="errors.has('rate')">
                      {{ errors.first("rate") }}
                    </div>
                  </div>
                  <div class="form-group col-6">
                    <label class="control-label">Max Rate Amount</label>
                    <input
                      type="text"
                      id="max_rate_amount"
                      name="max_rate_amount"
                      v-model="value.max_rate_amount"
                      v-bind:class="{
                        'has-error': errors.has('max_rate_amount'),
                      }"
                      class="form-control max_rate_amount"
                      placeholder="Max Rate Amount"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('max_rate_amount')"
                    >
                      {{ errors.first("max_rate_amount") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">Currency</label>
                    <input
                      type="text"
                      id="currency"
                      name="currency"
                      v-model="value.currency"
                      v-bind:class="{ 'has-error': errors.has('currency') }"
                      v-validate="'required'"
                      class="form-control currency"
                      placeholder="Currency"
                    />
                    <div
                      class="help text-danger"
                      v-show="errors.has('currency')"
                    >
                      {{ errors.first("currency") }}
                    </div>
                  </div>
                  <div class="form-group col-6 required">
                    <label class="control-label">App-ID</label>
                    <select
                      id="app_id"
                      name="app_id"
                      v-model="value.app_id"
                      v-bind:class="{ 'has-error': errors.has('app_id') }"
                      v-validate="'required'"
                      class="form-control"
                    >
                      <option
                        v-for="application in allApplications"
                        :value="application.app_id"
                        :key="application.app_id"
                      >
                        {{ application.name }}
                      </option>
                    </select>
                    <div class="help text-danger" v-show="errors.has('app_id')">
                      {{ errors.first("app_id") }}
                    </div>
                  </div>
                  <div class="has-many col-12">
                    <h4 class="site-heading my-3">
                      <span>Rating Condition</span>
                    </h4>
                    <div
                      class="form-row align-items-end"
                      v-for="(
                        rating_condition, index
                      ) in value.rating_condition"
                      :key="index"
                    >
                      <div class="form-group col-6 required">
                        <label class="control-label">Status</label>
                        <select
                          id="rating_condition.status"
                          name="rating_condition.status"
                          v-model="rating_condition.status"
                          v-bind:class="{
                            'has-error': errors.has('rating_condition.status'),
                          }"
                          v-validate="'required'"
                          class="form-control"
                        >
                          <option :value="1">Active</option>
                          <option :value="0">Inactive</option>
                        </select>
                        <div
                          class="help text-danger"
                          v-show="errors.has('rating_condition.status')"
                        >
                          {{ errors.first("rating_condition.status") }}
                        </div>
                      </div>
                      <div class="form-group col-6 required">
                        <label class="control-label">Name</label>
                        <select
                          id="rating_condition.name"
                          name="rating_condition.name"
                          v-bind:class="{
                            'has-error': errors.has('rating_condition.name'),
                          }"
                          v-validate="'required'"
                          v-model="rating_condition.name"
                          class="form-control rating_condition.name"
                        >
                          <option
                            v-for="ratingConditionName in allRatingConditionName"
                            :value="ratingConditionName.name"
                            :key="ratingConditionName.id"
                          >
                            {{ ratingConditionName.name }}
                          </option>
                        </select>
                        <div
                          class="help text-danger"
                          v-show="errors.has('rating_condition.name')"
                        >
                          {{ errors.first("rating_condition.name") }}
                        </div>
                      </div>
                      <div class="form-group col-6 required">
                        <label class="control-label">Operator</label>
                        <select
                          id="rating_condition.op"
                          name="rating_condition.op"
                          v-bind:class="{
                            'has-error': errors.has('rating_condition.op'),
                          }"
                          v-validate="'required'"
                          v-model="rating_condition.op"
                          class="form-control rating_condition.op"
                        >
                          <option value="=">=</option>
                          <option value="!=">!=</option>
                          <option value=">">&gt;</option>
                          <option value="<">&lt;</option>
                          <option value=">=">&gt;=</option>
                          <option value="<=">&lt;=</option>
                        </select>
                        <div
                          class="help text-danger"
                          v-show="errors.has('rating_condition.op')"
                        >
                          {{ errors.first("rating_condition.op") }}
                        </div>
                      </div>
                      <div class="form-group col-6 required">
                        <label class="control-label">Value</label>
                        <input
                          type="text"
                          id="rating_condition.value"
                          name="rating_condition.value"
                          v-bind:class="{
                            'has-error': errors.has('rating_condition.value'),
                          }"
                          v-validate="'required'"
                          v-model="rating_condition.value"
                          class="form-control rating_condition.value"
                          placeholder="Value"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('rating_condition.value')"
                        >
                          {{ errors.first("rating_condition.value") }}
                        </div>
                      </div>
                      <div class="form-group col-6">
                        <label class="control-label">Operator 2</label>
                        <select
                          id="rating_condition.op2"
                          name="rating_condition.op2"
                          v-bind:class="{
                            'has-error': errors.has('rating_condition.op2'),
                          }"
                          v-model="rating_condition.op2"
                          class="form-control rating_condition.op2"
                        >
                          <option value="=">=</option>
                          <option value="!=">!=</option>
                          <option value=">">&gt;</option>
                          <option value="<">&lt;</option>
                          <option value=">=">&gt;=</option>
                          <option value="<=">&lt;=</option>
                        </select>
                        <div
                          class="help text-danger"
                          v-show="errors.has('rating_condition.op2')"
                        >
                          {{ errors.first("rating_condition.op2") }}
                        </div>
                      </div>
                      <div class="form-group col-6">
                        <label class="control-label">Value 2</label>
                        <input
                          type="text"
                          id="rating_condition.value2"
                          name="rating_condition.value2"
                          v-bind:class="{
                            'has-error': errors.has('rating_condition.value2'),
                          }"
                          v-model="rating_condition.value2"
                          class="form-control rating_condition.value2"
                          placeholder="Value 2"
                        />
                        <div
                          class="help text-danger"
                          v-show="errors.has('rating_condition.value2')"
                        >
                          {{ errors.first("rating_condition.value2") }}
                        </div>
                      </div>
                      <div class="form-group col-md-12 border-bottom pb-3">
                        <button
                          type="button"
                          class="btn btn-danger float-right"
                          @click="deleteRating_condition(index)"
                        >
                          <i class="fa fa-trash"></i> Remove
                        </button>
                      </div>
                    </div>
                    <div class="col-12">
                      <button
                        type="button"
                        @click="addRating_condition"
                        class="btn btn-success"
                      >
                        <i class="fa fa-plus"></i> New
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <button type="submit" v-if="!is_edit" class="btn btn-primary">
                Submit
              </button>
              <button type="submit" v-if="is_edit" class="btn btn-primary">
                Update
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { CBSProductRatingApi, CBSCommonApi } from "@/services/api";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

export default {
  name: "RatingConfigForm",
  components: {
    DatePicker,
  },
  computed: {
    ...mapGetters(["profile"]),
  },
  data: () => ({
    isSelectorLoading: false,
    is_loading: false,
    is_edit: false,
    params: {},
    value: {
      status: 1,
      rating_condition: [],
    },
    allApplications: [],
    allRatingPlan: [],
    allRatingType: [],
    allRatingConditionName: [],
    pre: {},
  }),
  methods: {
    handleSubmission() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.is_loading = true;
          if (this.is_edit) {
            this.value.updated_by = this.profile.id;
            CBSProductRatingApi.updateRatingConfig(this.params.id, this.value)
              .then((response) => {
                if (response.code == 200) {
                  this.$router.push({ name: "RatingConfigList" });
                  this.$toaster.success(response.message);
                } else {
                  this.$toaster.error(response.message);
                }
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.response.data);
              })
              .finally(() => {
                this.is_loading = false;
              });
          } else {
            this.value.organization_ref_id = this.profile.organization_ref_id;
            this.value.user_ref_id = this.profile.user_ref_id;
            this.value.role_ref_id = this.profile.role_ref_id;
            this.value.created_by = this.profile.id;
            CBSProductRatingApi.storeRatingConfig(this.value)
              .then((response) => {
                if (response.code == 200) {
                  this.$toaster.success(response.message);
                  this.$router.push({ name: "RatingConfigList" });
                } else {
                  this.$toaster.error(response.message);
                }
              })
              .catch((error) => {
                this.$setErrorsFromResponse(error.response.data);
              })
              .finally(() => {
                this.is_loading = false;
              });
          }
        }
      });
    },
    addRating_condition: function () {
      this.value.rating_condition.push({});
    },

    deleteRating_condition: function (index) {
      this.value.rating_condition.splice(index, 1);
    },
    getDetail: function (id) {
      CBSProductRatingApi.showRatingConfig(id)
        .then((item) => {
          this.value = item;
        })
        .catch((error) => {
          this.$toaster.error(error.response.data.message);
        })
        .finally(() => {
          this.is_loading = false;
        });
    },
    getApplications: function () {
      CBSCommonApi.getAllApplications().then((response) => {
        this.allApplications = response;
      });
    },
    getRatingPlan: function () {
      CBSCommonApi.getAllRatingPlan().then((response) => {
        this.allRatingPlan = response;
      });
    },
    getRatingType: function () {
      CBSCommonApi.getAllRatingType().then((response) => {
        this.allRatingType = response;
      });
    },
    getRatingConditionName: function () {
      CBSCommonApi.getAllRatingConditionName().then((response) => {
        this.allRatingConditionName = response;
      });
    },
    async initialize() {
      this.is_loading = true;
      this.params = this.$route.params;

      if (!_.isEmpty(this.params) && this.params.id !== undefined) {
        this.is_edit = true;
      }
      if (this.is_edit) {
        this.getDetail(this.params.id);
      }
      this.getApplications();
      this.getRatingPlan();
      this.getRatingType();
      this.getRatingConditionName();
      this.is_loading = false;
    },
  },
  mounted() {
    this.initialize();
  },
};
</script>
